<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">{{'KATIE_BECKETT_TITLE' | globalTranslate}}</h1>
    <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
    </button>
  </div>
  <div class="modal-body">
    <h2>
      <strong>{{'KATIE_BECKETT_HEADER' | globalTranslate}}</strong>
    </h2>
    <hr />
    <p>{{'KATIE_BECKETT_INFO' | globalTranslate}}</p>
  </div>
</div>